import {
  AuthRegisterConnectorApollo,
  SalePaymentMethodsConnectorApollo,
} from '@front-activerse/common-components';
import SignUpContainer from './SignUpContainer';

const SignUpPage = ({
  redirectToPathAfterSuccessFromRoute,
  action,
  displayAppleButton = true,
  displayFacebookButton = true,
  displayGoogleButton = true,
  loginButtonURL,
}) => {
  return (
    <AuthRegisterConnectorApollo>
      {({ ...register }) => (
        <SalePaymentMethodsConnectorApollo amount={100}>
          {({ paymentMethods }) => (
            <SignUpContainer
              {...register}
              paymentMethods={paymentMethods}
              redirectToPathAfterSuccess={redirectToPathAfterSuccessFromRoute}
              action={action}
              displayAppleButton={displayAppleButton}
              displayFacebookButton={displayFacebookButton}
              displayGoogleButton={displayGoogleButton}
              loginButtonURL={loginButtonURL}
            />
          )}
        </SalePaymentMethodsConnectorApollo>
      )}
    </AuthRegisterConnectorApollo>
  );
};

export default SignUpPage;
